const getters = {
  listaDeDocumentosFavoritos: (state) => state.listaDeDocumentosFavoritos
}

export default getters
